import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { DndProvider } from "react-dnd";
import { MultiBackend, getBackendOptions } from "@minoru/react-dnd-treeview";
import { CustomSnackbarProvider } from "./CustomSnackbarProvider";
import { SnackbarProvider } from "notistack";
import store from './store';
import './index.css';
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import 'simplebar-react/dist/simplebar.min.css';

const theme = createTheme({
  typography: {
    fontFamily: 'Arial, Helvetica, sans-serif',
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <SnackbarProvider maxSnack={5}>
          <DndProvider backend={MultiBackend} options={getBackendOptions()}>
            <CustomSnackbarProvider>
              <App />
            </CustomSnackbarProvider>
          </DndProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
